const brunch = [
  {
    category: "Breakfast",
    name: "Avocado Toast",
    info: "Sliced avocado and cherry tomatoes on toast, topped with a poached egg",
    price: 8,
  },
  {
    category: "Breakfast",
    name: "LOX BAGEL",
    info: "Smoked salmon lox, capers, chive cream cheese, and red onions",
    price: 11,
  },
  {
    category: "Breakfast",
    name: "EGG BREAKFAST SANDO",
    info: "Folded eggs with green onions, melted cheese, garlic aioli, on a brioche bun",
    price: 9,
  },
  {
    category: "Breakfast",
    name: "CHILAQUILES",
    info: `Choice of: Salsa Roja | Salsa Verde.
    Fried tortilla chip simmered in salsa of
    choice, Topped with two over easy eggs,
    cheese, onions, and sour cream`,
    price: 15.5,
  },
  {
    category: "Breakfast",
    name: "HONG KONG FRENCH TOAST",
    info: `Choice of: Ube Cream Cheese | Nutella.
    Panko battered Pullman bread stuffed with
    flavor of choice, drizzled with condensed
    milk, and topped with seasonal fruit and
    house-made whipped cream`,
    price: 13,
  },
  {
    category: "Sandwiches",
    name: "Avocado BLT",
    info: "Avocado, bacon, lettuce, tomato, and aioli on sourdough bread",
    price: 12,
  },
  {
    category: "Sandwiches",
    name: "Brisket Sando",
    info: "Brisket, swiss cheese, roasted pepper aioli and cucumber on french bread. Served with waffle fries",
    price: 17,
  },
  {
    category: "Sandwiches",
    name: "KFC",
    info: "Korean fried chicken-inspired sando with a sweet gochujang pepper sauce, spicy mayo, and slaw on a toasted brioche bun. Served with potato wedges",
    price: 16.2,
  },
  {
    category: "Sandwiches",
    name: "CHIPOTLE CHICKEN CLUB",
    info: "Chicken, bacon, lettuce, and tomato with chipotle mayo on French bread. Served with potato wedges.",
    price: 14.7,
  },
  {
    category: "Sandwiches",
    name: "LONGANISA",
    info: "Longanisa sausage patty, sunny-side-up egg, jack cheese, banana ketchup, and jalapeno on a brioche bun. Served with potato wedges.",
    price: 16.2,
  },
  {
    category: "Sandwiches",
    name: "HOT KARAAGE",
    info: "Spicy Japanese-style fried chicken, scrambled egg, Swiss cheese, and garlic aioli on buttered toast. Served with potato wedges",
    price: 17.3,
  },
  {
    category: "Sandwiches",
    name: "SAIGON CHICKEN",
    info: "Fried chicken thigh coated in a sweet garlic fish sauce. Topped with pickled daikon and carrots and fresh cilantro on buttered toast. Served with a side salad",
    price: 16.2,
  },
  {
    category: "Plates",
    name: "LOCOMOCO",
    info: "Smashed beef patty, onions, sweet gravy, sunny-side-up egg, micro cilantro, and truffle salt served over rice",
    price: 16.3,
  },
  {
    category: "Plates",
    name: "RICE BOWL",
    info: "Saigon Chicken | Katsu Chicken | Longanisa",
    price: 11.5,
  },
  {
    category: "Skillets",
    name: "SISIG SKILLET",
    info: "Crispy pork belly and green onion topped with pickled red onion, aioli, egg yolk. Served with a side of garlic rice.",
    price: 18,
  },
  {
    category: "Skillets",
    name: "STEAK AND EGGS",
    info: "8 oz. New York strip steak topped with fried garlic and shallots. Served with a sunny-side-up egg, steamed rice, and house sauce.",
    price: 20,
  },
  {
    category: "Skillets",
    name: "BREAKFAST SKILLET",
    info: "Scrambled egg, potato, sausage, bacon, and longanisa in chili oil topped with cheese, jalapenos, and green onions. Served with toasted bread",
    price: 16.8,
  },
  {
    category: "Udon",
    name: "Miso Carbonara",
    info: "Bacon with gochujang and mayo sauce, green onion, topped with cheese and egg yolk",
    price: 16.8,
  },
  {
    category: "Udon",
    name: "Kimchi Udon",
    info: "Pork Belly, garlic, green onions, topped with fried egg, seaweed, and sesame seeds",
    price: 16,
  },
];

export default brunch;
